document.querySelectorAll('a').forEach( aHref=> aHref.addEventListener("click", (event)=> {
  // Immediately return if the link has the cgx-faq-link class to skip popup behavior
  if (event.currentTarget.classList.contains('cgx-faq-link') || event.currentTarget.classList.contains('cgx-blog-btn-link')) {
    return;
  }
  
  if (!event.target.classList.contains('toc-link') && !event.target.parentElement.classList.contains('toc-link')) {
    event.preventDefault();
   if ([...event.target.classList].includes('icon-arrow-next') && [...event.target.classList].includes('icon-for-mob')) {
    return false;
   }
    let link =  event.currentTarget.getAttribute("href");
    if (event.ctrlKey || event.metaKey) {
        window.open(link, '_blank');
    } else if (event.shiftKey) {
        window.open(link, '');
    } else {
        if (link != null) {
            let checkHrefID = event.currentTarget.getAttribute("id");
            let hasClass = event.target.classList.contains('no-popup');
            let target_blank = event.target.classList.contains('target_blank');
            if(checkHrefID === 'send_email_pdf' || checkHrefID === 'download_pdf_button' || hasClass  || link.includes('.pdf') || target_blank ){
                window.open(link, '_blank');
            } else if(link.includes('http')) {
                if (link.includes('www.facebook.com/pollenkontroll.no')){
                  openNoPopup (link);
                }
                else{
                  if (!link.includes('pollenkontroll.no') && !link.includes('shopify.com') && !link.includes('/apps/pages/')) openNoPopup (link);
                  else window.location.href= link;
                }
            }
            else window.location.href= link;
        }
    }
  }
}));
function openNoPopup (link){
    document.getElementById("yes-confirm-btn").setAttribute("data-externalUrl", link);
    document.getElementById("btn-external_link_model").click();
}
document.getElementById('yes-confirm-btn').addEventListener("click", (event)=> {
    event.preventDefault();
    let link =  event.currentTarget.getAttribute("data-externalUrl");
    window.open(link, "_blank");
    document.getElementById('ModalClose-external_link_modeln').click();
});
document.getElementById('no-popup-close').addEventListener('click', ()=>{
    document.getElementById('ModalClose-external_link_modeln').click();
});
